export default __webpack_public_path__ + "static/media/Inter-Thin.f341ca51.ttf";